import { render, staticRenderFns } from "./WorkspaceProjectDeletionModal.vue?vue&type=template&id=81ebaa26&scoped=true&"
import script from "./WorkspaceProjectDeletionModal.vue?vue&type=script&lang=js&"
export * from "./WorkspaceProjectDeletionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ebaa26",
  null
  
)

export default component.exports